import { create, resetAllStores } from 'src/store/store';
import { removeRefreshToken, removeToken } from 'utils/localStorage';

export interface AuthState {
  isSignedIn: boolean,
  login: () => void,
  logout: () => void
}

const initialState = {
  isSignedIn: false
}

const useAuthStore = create<AuthState>()((set) => ({
  ...initialState,
  login: (): void => set(() => ({ isSignedIn: true })),
  logout: (): void => {
    resetAllStores();
    removeToken();
    removeRefreshToken();
  }
}))


export default useAuthStore;